import {Col, Row, Tooltip, Typography} from "antd";
import {InfoCircleFilled} from "@ant-design/icons";
import React from "react";

const Explainer = ({title, tooltip, middle, level=5})=>{
  return (
      <Row wrap={false} align={'middle'} justify={'space-between'}>
        <Col>
            {level >= 6 && (<Typography.Text strong>{title}</Typography.Text>)}
            {level < 6 && (<Typography.Title level={level} style={{fontWeight: '500'}}>{title}</Typography.Title>)}
        </Col>
          {middle && (
              <Col>
                  {middle}
              </Col>
          )}
        <Col flex={'0 0 30px'}>
            <Tooltip title={tooltip} color={'#2db7f5'} style={{fontWeight: '300'}}>
                <InfoCircleFilled style={{fontSize: 20, color: '#1890ff'}}/>
            </Tooltip>
        </Col>
      </Row>
  )
}
export default Explainer;